// extracted by mini-css-extract-plugin
module.exports = {"buttonContainer":"_Copy-styles-module--buttonContainer--1mwWO","button":"_Copy-styles-module--button--3ay31"};